/**
 * @generated SignedSource<<53c6214875e3ef2c7c4dfe40db9501c7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type UpdateSeoInput = {
  metaDescription?: string | null;
  metaTitle?: string | null;
  slug?: string | null;
};
export type SeoTabMutation$variables = {
  id: string;
  input: UpdateSeoInput;
};
export type SeoTabMutation$data = {
  readonly updateSeo: {
    readonly id: string;
    readonly metaDescription: string | null;
    readonly metaTitle: string | null;
    readonly slug: string;
  } | null;
};
export type SeoTabMutation = {
  response: SeoTabMutation$data;
  variables: SeoTabMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      },
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "Seo",
    "kind": "LinkedField",
    "name": "updateSeo",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "slug",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "metaTitle",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "metaDescription",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SeoTabMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SeoTabMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "a95652bb90d85aab1e989c0e00cd5c9c",
    "id": null,
    "metadata": {},
    "name": "SeoTabMutation",
    "operationKind": "mutation",
    "text": "mutation SeoTabMutation(\n  $id: ID!\n  $input: UpdateSeoInput!\n) {\n  updateSeo(id: $id, input: $input) {\n    id\n    slug\n    metaTitle\n    metaDescription\n  }\n}\n"
  }
};
})();

(node as any).hash = "0156d1841b2e6e9861cd55eada20c504";

export default node;
